import React from 'react'
import className from 'classnames'
export default function Text({name , children}) {
    const classes = className('',{
        'me-[6px] font-tajawal-regular text-lg font-medium': name
    })
  return (
        <span className={classes}>{children}</span>

  )
}
